import styled from 'styled-components';

export const HeaderContainer = styled.div`
  display: flex;
  padding: 4px 26px;
  gap: 9px;
`;

export const ViewSettingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #EDEDED;
  border-radius: 11.5px;
  background: #F7F7F7;
  width: max-content;
  cursor: pointer;
  padding: 4px 8px;
  gap: 4px;
`;
